<template>
	<div class="device-map">
		<div id="google-map-container" class="dmap" :class="{ dmapShowAre: isAddDevice == 'ADD' || isAddDevice == 'EDIT' }">
			<!-- 用于InfoWindow内容的组件，使用visibility:hidden而非v-show来保留DOM结构 -->
			<device-detail :currentDetail='mapDeviceList[currentDeviceIndex]' :isMap='false'
				style="visibility:hidden;position:absolute;" v-if="isDetail && mapDeviceList[currentDeviceIndex] != null"
				ref='infoWindow'>
			</device-detail>
		</div>
		<i class="isdraw" v-show="isDetail">
			<img src="@/assets/images/public/public_copy.png" @click="changeToDraw" />
		</i>
		<div class="area" v-if="isAddDevice == 'ADD' || isAddDevice == 'EDIT'">
			<template v-if="!currentMark || address == '' || address == null">
				{{ $t('terminal.mapTip1') }}
			</template>
			<template v-else>
				<div class="overflow-hidden" style="line-height: 20px;color: #0d8867;">
					{{ $t('terminal.addDetail') }}:{{ this.address }}</div>
				<div style="line-height: 20px;color: #58c8a9;">
					<span>{{ `${$t('terminal.lng')}:${this.latlng[0]}` }}</span>
					<span style="margin-left: 20px;">{{ `${$t('terminal.lat')}:${this.latlng[1]}` }}</span>
				</div>
			</template>
		</div>
	</div>
</template>

<script>
// eslint-disable-next-line
/* global google */
import { runStateInfo } from "@/assets/scripts/runState";
import { changeDeviceStateName } from "@/assets/scripts/changeDeviceStateName";
import { mPagination } from "@/components/basics/mixins";
import DeviceDetail from './DeviceDetail.vue';
export default {
	name: "GoogleMap",
	mixins: [mPagination],
	components: {
		DeviceDetail
	},
	data() {
		return {
			map: null,
			mapType: "normal",
			currentMark: null,
			search_data: null,
			currentDeviceIndex: 0,
			isShowDetail: false,
			DeviceDetail: {},
			isOpenDevice: false,
			isSearch: false,
			isDraw: false,
			flag: false,
			singlemark: null,
			mapDeviceList: [],
			address: '',
			latlng: [null, null],
			markDetail: {
				citycode: null,
				adcode: null,
				address: null,
				position: [null, null]
			},
			searchResults: [],
			markers: [],
			drawingManager: null,
			// 存储当前的绘图对象
			currentDrawing: null,
			// 存储地图点击事件监听器
			mapClickHandler: null,
			// 加载状态
			mapLoaded: false,
			// 信息窗口实例
			infoWindow: null
		}
	},
	props: {
		deviceList: {
			type: Array,
			default: function () {
				return []
			}
		},
		deviceName: {
			type: String,
			default: ''
		},
		isDetail: {
			type: Boolean,
			default: true
		},
		isAddDevice: {
			type: String,
			default: 'none'
		},
		form: {
			type: Object
		}
	},
	mounted() {
		// 处理设备列表
		if (this.deviceList.length != 0) {
			this.deviceList.forEach(ele => {
				if (ele.lat !== null && ele.lng !== null && ele.lat != '0.0000000000') {
					ele.runStateInfo = runStateInfo(ele.run_state, ele.group_run_status);
					ele.runStateInfo = changeDeviceStateName(ele.runStateInfo);
					this.mapDeviceList.push(ele);
				}
			})
		}

		// 加载谷歌地图
		this.loadGoogleMaps();
	},
	methods: {
		// 创建自定义标签覆盖物
		createMarkerLabel(map, position, content) {
			// 创建一个简单的div元素作为标签
			const labelDiv = document.createElement('div');
			labelDiv.className = 'google-map-marker-label';
			labelDiv.innerText = content;
			labelDiv.style.cssText = `
					position: absolute;
    z-index: 2;
    border: 1px solid blue;
    background-color: white;
    white-space: nowrap;
    cursor: default;
    padding: 3px;
    font-size: 12px;
    line-height: 14px;
				`;

			// 创建一个覆盖物
			const labelOverlay = new google.maps.OverlayView();
			labelOverlay.setMap(map);
			labelOverlay.position = position;
			labelOverlay.div = labelDiv;

			// 实现必要的方法
			labelOverlay.onAdd = function () {
				const pane = this.getPanes().overlayLayer;
				pane.appendChild(this.div);
			};

			labelOverlay.draw = function () {
				const projection = this.getProjection();
				const pos = projection.fromLatLngToDivPixel(this.position);
				// 设置标签位置在标记的右下方
				this.div.style.left = (pos.x + 15) + 'px';
				this.div.style.top = (pos.y + 15) + 'px';
			};

			labelOverlay.onRemove = function () {
				if (this.div && this.div.parentNode) {
					this.div.parentNode.removeChild(this.div);
				}
			};

			return labelOverlay;
		},

		loadGoogleMaps() {
			// 动态加载谷歌地图API
			const script = document.createElement('script');
			script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyCkbvahjHlJ7-8xcbbjEQF8ZuH01CNrrLw&libraries=places,drawing&callback=initGoogleMap`;
			script.async = true;
			script.defer = true;
			document.head.appendChild(script);

			// 设置全局回调函数
			window.initGoogleMap = () => {
				this.mapLoaded = true;
				this.initMap();
			};
		},

		initMap() {
			let defaultCenter = { lat: 40.7167, lng: -74.0059 };
			if (process.env.VUE_APP_INDIA === 'true') {
				// 28.668825279039027, 77.50473637586946
				defaultCenter = { lat: 28.668825279039027, lng: 77.50473637586946 };
			}
			let zoom = 11;
			// 编辑模式时使用已有位置
			if (this.isAddDevice == 'EDIT' && this.form.lng !== null && this.form.lng !== '0.0000000000') {
				defaultCenter = { lat: Number(this.form.lat), lng: Number(this.form.lng) };
			}

			if (navigator.geolocation) {
				navigator.geolocation.getCurrentPosition(
					(position) => {
						// 成功获取位置，设置地图中心为用户当前位置
						const userLocation = {
							lat: position.coords.latitude,
							lng: position.coords.longitude
						};
						this.map = new google.maps.Map(document.getElementById('google-map-container'), {
							center: userLocation,
							zoom: zoom,
							mapTypeId: google.maps.MapTypeId.ROADMAP
						});
					},
					(error) => {
						// 获取位置失败，使用默认中心
						console.error("获取位置失败:", error);
						this.map = new google.maps.Map(document.getElementById('google-map-container'), {
							center: defaultCenter,
							zoom: zoom,
							mapTypeId: google.maps.MapTypeId.ROADMAP
						});
					}
				);
			} else {
				// 浏览器不支持 Geolocation，使用默认中心
				console.warn("浏览器不支持地理位置定位");
				this.map = new google.maps.Map(document.getElementById('google-map-container'), {
					center: defaultCenter,
					zoom: zoom,
					mapTypeId: google.maps.MapTypeId.ROADMAP
				});
			}

			// 初始化地图
			// this.map = new google.maps.Map(document.getElementById('google-map-container'), {
			// 	center: center,
			// 	zoom: zoom,
			// 	mapTypeId: google.maps.MapTypeId.ROADMAP
			// });

			// 初始化信息窗口
			this.infoWindow = new google.maps.InfoWindow({
				pixelOffset: new google.maps.Size(0, -20), // 调整信息窗口显示位置
				disableAutoPan: false // 自动平移以确保信息窗口可见
			});

			// 添加地图点击事件，点击地图空白区域时关闭InfoWindow
			this.map.addListener('click', () => {
				this.isShowDetail = false;
				// 关闭信息窗口
				this.closeInfoWindow();
			});

			// 编辑模式时添加标记
			if (this.isAddDevice == 'EDIT') {
				this.markDetail.position = [this.form.lng, this.form.lat];
				this.latlng = [Number(this.form.lng), Number(this.form.lat)];
				this.address = this.form.formattedAddress;
				this.addMarker({
					position: { lat: Number(this.form.lat), lng: Number(this.form.lng) },
					title: this.form.name
				});
			}

			// 设置设备标记
			this.setDeviceSite();

			// 添加地图点击事件
			this.getLatLng();
		},

		addMarker(options) {
			// 如果已有标记，先移除
			if (this.currentMark) {
				this.currentMark.setMap(null);
			}

			// 创建新标记
			this.currentMark = new google.maps.Marker({
				position: options.position,
				title: options.title || '',
				map: this.map
			});

			// 添加点击事件阻止冒泡
			this.currentMark.addListener('click', (e) => {
				e.stopPropagation ? e.stopPropagation() : (e.cancelBubble = true);
			});
		},

		setDeviceSite() {
			// 清除现有标记和标签
			this.markers.forEach(marker => {
				marker.setMap(null);
				// 移除关联的标签
				if (marker.labelOverlay) {
					marker.labelOverlay.setMap(null);
				}
			});
			this.markers = [];

			// 添加新标记
			for (let i = 0; i < this.mapDeviceList.length; i++) {
				const device = this.mapDeviceList[i];
				const marker = new google.maps.Marker({
					position: { lat: Number(device.lat), lng: Number(device.lng) },
					title: device.name,
					map: this.map,
					// 根据设备状态设置图标颜色，参照高德地图实现：run_state为0时显示红色，否则显示绿色
					icon: {
						path: google.maps.SymbolPath.CIRCLE,
						scale: 10,
						fillColor: device.run_state == 0 ? '#FF0000' : '#00FF00',
						fillOpacity: 0.8,
						strokeColor: '#000000',
						strokeWeight: 1
					}
				});

				// 创建设备名称标签，显示在标记右下角
				const labelColor = device.run_state == 0 ? '#FF0000' : '#00FF00';
				const labelOverlay = this.createMarkerLabel(this.map, marker.getPosition(), device.name, {
					color: labelColor
				});

				// 存储标记索引和标签引用
				marker.deviceIndex = i;
				marker.deviceId = device.id;
				marker.labelOverlay = labelOverlay;

				// 添加点击事件
				marker.addListener('click', (e) => {
					// 阻止事件冒泡到地图
					e.stopPropagation ? e.stopPropagation() : (e.cancelBubble = true);

					this.currentDeviceIndex = i;

					// 使用setTimeout确保DOM已更新
					setTimeout(() => {
						this.openInfoWindow(marker);
					}, 0);

					// 发送地址信息
					let pos = [device.lng, device.lat];
					this.$emit('showAddress', pos, device.formattedAddress || '');
				});

				this.markers.push(marker);
			}
		},

		searchAddress() {
			if (!this.search_data || this.search_data.trim() === '') {
				this.isSearch = false;
				this.searchResults = [];
				return;
			}

			if (!this.mapLoaded || !window.google) {
				console.warn('Google Maps API 尚未加载完成');
				return;
			}

			this.isSearch = true;
			const service = new google.maps.places.PlacesService(this.map);

			service.textSearch({
				query: this.search_data,
				fields: ['formatted_address', 'geometry', 'name']
			}, (results, status) => {
				if (status === google.maps.places.PlacesServiceStatus.OK) {
					this.searchResults = results;
				} else {
					this.searchResults = [];
					console.error('搜索失败:', status);
				}
			});
		},

		selectSearchResult(item) {
			this.latlng = [item.geometry.location.lng(), item.geometry.location.lat()];
			this.address = item.formatted_address;
			this.isSearch = false;

			// 添加标记
			this.addMarker({
				position: item.geometry.location,
				title: this.deviceName
			});

			// 发送数据
			this.markDetail.position = this.latlng;
			this.markDetail.address = this.address;
			// 设置默认值以确保amapData方法中的条件判断通过
			this.markDetail.citycode = this.markDetail.citycode || '0000';
			this.markDetail.adcode = this.markDetail.adcode || '000000';
			this.$emit('amapData', this.markDetail);
			this.$emit('showAddress', this.latlng, this.address);
		},

		closeSearch() {
			this.search_data = '';
			this.isSearch = false;
			this.searchResults = [];
		},

		changeToDraw() {
			this.isDraw = !this.isDraw;

			if (this.isDraw) {
				this.initDrawingManager();
				// 添加地图点击事件以清除之前的矩形
				if (!this.mapClickHandler) {
					this.mapClickHandler = this.map.addListener('click', () => {
						if (this.currentDrawing) {
							this.currentDrawing.setMap(null);
							this.currentDrawing = null;
						}
					});
				}
			} else if (this.drawingManager) {
				this.drawingManager.setMap(null);
				// 移除地图点击事件
				if (this.mapClickHandler) {
					google.maps.event.removeListener(this.mapClickHandler);
					this.mapClickHandler = null;
				}
				// 清除当前绘图
				if (this.currentDrawing) {
					this.currentDrawing.setMap(null);
					this.currentDrawing = null;
				}
			}
		},

		initDrawingManager() {
			if (!this.mapLoaded || !window.google) {
				console.warn('Google Maps API 尚未加载完成');
				return;
			}

			// 清除之前的绘图管理器
			if (this.drawingManager) {
				this.drawingManager.setMap(null);
			}

			this.drawingManager = new google.maps.drawing.DrawingManager({
				drawingMode: google.maps.drawing.OverlayType.RECTANGLE,
				drawingControl: true,
				drawingControlOptions: {
					position: google.maps.ControlPosition.TOP_CENTER,
					drawingModes: [google.maps.drawing.OverlayType.RECTANGLE]
				},
				rectangleOptions: {
					fillColor: '#FF0000',
					fillOpacity: 0.2,
					strokeColor: '#FF0000',
					strokeOpacity: 0.5,
					strokeWeight: 1
				}
			});

			this.drawingManager.setMap(this.map);

			// 监听矩形完成事件
			google.maps.event.addListener(this.drawingManager, 'rectanglecomplete', (rectangle) => {
				// 清除之前的绘图
				if (this.currentDrawing) {
					this.currentDrawing.setMap(null);
				}
				this.currentDrawing = rectangle;
				// 处理设备选择
				this.processRectangleSelection(rectangle);
				// 清除绘图模式
				this.drawingManager.setDrawingMode(null);
			});
		},

		// 打开信息窗口方法
		openInfoWindow(marker) {
			if (!this.mapLoaded || !window.google || !this.$refs.infoWindow || !this.infoWindow) {
				return;
			}

			// 获取device-detail组件的DOM元素
			const contentElement = this.$refs.infoWindow.$el.cloneNode(true);
			// 移除visibility:hidden样式
			contentElement.style.visibility = 'visible';
			contentElement.style.position = 'relative';

			// 设置InfoWindow内容并打开
			this.infoWindow.setContent(contentElement);
			this.infoWindow.open(this.map, marker);
		},

		// 关闭信息窗口方法
		closeInfoWindow() {
			if (this.infoWindow) {
				this.infoWindow.close();
			}
		},

		processRectangleSelection(rectangle) {
			if (!this.mapLoaded || !window.google) {
				console.warn('Google Maps API 尚未加载完成');
				return;
			}

			const bounds = rectangle.getBounds();
			const orderDevice = [];

			this.mapDeviceList.forEach(ele => {
				const point = new google.maps.LatLng(Number(ele.lat), Number(ele.lng));
				if (bounds.contains(point)) {
					orderDevice.push({
						name: ele.name,
						id: ele.id,
						type_id: ele.type_id,
						sn: ele.sn
					});
				}
			});

			this.$emit('seleceDevice', orderDevice);
		},

		getLatLng() {
			this.map.addListener('click', (e) => {
				this.latlng = [e.latLng.lng(), e.latLng.lat()];

				// 获取地址信息
				this.geocodeLatLng(e.latLng);
			});
		},

		geocodeLatLng(latLng) {
			if (!this.mapLoaded || !window.google) {
				console.warn('Google Maps API 尚未加载完成');
				return;
			}

			const geocoder = new google.maps.Geocoder();
			geocoder.geocode({ 'location': latLng }, (results, status) => {
				if (status === google.maps.GeocoderStatus.OK && results[0]) {
					this.address = results[0].formatted_address;

					// 添加标记
					this.addMarker({
						position: latLng,
						// title: this.deviceName
					});

					// 更新标记详情
					this.markDetail.position = this.latlng;
					this.markDetail.address = this.address;
					// 设置默认值以确保amapData方法中的条件判断通过
					this.markDetail.citycode = this.markDetail.citycode || '0000';
					this.markDetail.adcode = this.markDetail.adcode || '000000';
					this.$emit('amapData', this.markDetail);
					this.$emit('showAddress', this.latlng, this.address);
				} else {
					console.error('地理编码失败:', status);
					this.$message({
						type: 'warning',
						message: this.$t('terminal.matTip2')
					});
				}
			});
		}
	}
}
</script>

<style lang="scss" scoped>
.device-map {
	width: 100%;
	height: 100%;

	.area {
		height: 40px;
	}

	.dmap {
		width: 98%;
		height: 100%;
		margin: 0 auto;
		position: relative;
	}


	.isdraw {
		position: absolute;
		width: 30px;
		height: 30px;
		font-size: 20px;
		left: 20px;
		top: 50%;
		z-index: 1999;
		transform: translateY(-50%);
		cursor: pointer;

		img {
			width: 50px;
			height: 50px;
		}
	}

	.input-search {
		position: absolute;
		top: 10px;
		right: 75px;
		display: flex;
		justify-content: space-between;

		.panel {
			position: absolute;
			top: 40px;
			width: 205px;
			height: 200px;
			overflow: auto;
			background: white;
			border: 1px solid #ccc;
			border-radius: 4px;
			z-index: 2000;
		}

		.close {
			font-size: 20px;
			position: absolute;
			right: 10px;
			top: 12px;
			z-index: 2000;
		}

		.search-item {
			padding: 8px 10px;
			cursor: pointer;

			:hover {
				background-color: #f5f5f5;
			}
		}
	}

	.dmapShowAre {
		height: calc(100% - 40px)
	}

	.inner {
		height: 300px;
		overflow: auto;
	}
}
</style>